// Note:
// _menu: nếu là các menu
// _act: nếu là các action của button, ...

export const GlobalPolcies = {
  mXetMienMon: {
    left_menu: {
      dashboard: {
        home: '1',
        metabase: '1' // 1: web: menu left - DTTX Xét miễn môn - Dashboard
      },
      yeu_cau_xet_mien: '2', // 2: web: menu left - DTTX Xét miễn môn - Yêu cầu xét miễn
      thong_tin_sinh_vien: '',
      cai_dat: {
        dot_xet_mien: '4',         // 4: Đợt xét miễn
        nganh_hoc: '5',            // 5: Ngành
        khung_chuong_trinh: '6',   // 6: Khung
        quan_ly_nganh: '7',        // 7: Quyền quản lý
      },
      import_excel: {},
      dong_bo_du_lieu: '12'
    },
    action: {
      yeu_cau_xet_mien: {
        import_excel: '13',
        dao_tao_act: '8',        // 8: Button action đào tạo
        truong_nganh_act: '9',   // 9: Button action trưởng ngành
        quan_ly_act: '10',       // 10: Button action quản lý
        print: '18',       // 18: Button action print
        cancel: '19',       // Button action print,
        export: '20',       // Button action export,
      },
      dashboard: {
        tong_quan: "14",
        so_luong: "15",
        gan_day: "16",
        tong_quan_nganh: "17",
      }
    }
  }
};
